var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8199 14.49L18.8199 12.83C18.6099 12.46 18.4199 11.76 18.4199 11.35V8.82C18.4199 6.47 17.0399 4.44 15.0499 3.49C14.5299 2.57 13.5699 2 12.4699 2C11.3799 2 10.3999 2.59 9.87992 3.52C7.92992 4.49 6.57992 6.5 6.57992 8.82V11.35C6.57992 11.76 6.38992 12.46 6.17992 12.82L5.16992 14.49C4.76992 15.16 4.67992 15.9 4.92992 16.58C5.16992 17.25 5.73992 17.77 6.47992 18.02C8.41992 18.68 10.4599 19 12.4999 19C14.5399 19 16.5799 18.68 18.5199 18.03C19.2199 17.8 19.7599 17.27 20.0199 16.58C20.2799 15.89 20.2099 15.13 19.8199 14.49Z",
    fill: "#17233B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3099 20.01C14.8899 21.17 13.7799 22 12.4799 22C11.6899 22 10.9099 21.68 10.3599 21.11C10.0399 20.81 9.79991 20.41 9.65991 20C9.78991 20.02 9.91991 20.03 10.0599 20.05C10.2899 20.08 10.5299 20.11 10.7699 20.13C11.3399 20.18 11.9199 20.21 12.4999 20.21C13.0699 20.21 13.6399 20.18 14.1999 20.13C14.4099 20.11 14.6199 20.1 14.8199 20.07C14.9799 20.05 15.1399 20.03 15.3099 20.01Z",
    fill: "#17233B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification2);
export default __webpack_public_path__ + "static/media/notification2.2623dd03b6ac091e4efd1ed30f417160.svg";
export { ForwardRef as ReactComponent };